module.exports = __webpack_public_path__ + "static/media/kadesignb.491381a8.png";